import { FC, useEffect } from 'react'
import { useLazyQuery, useSubscription } from '@apollo/client'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import {
  GET_CASE_LEVEL_DASHBOARD,
  GetCaseLevelDashboardResponse
} from 'share/queries/cases'
import {
  ActiveCase,
  setActiveCase,
  loadFirstActiveCaseRecordFromResponse
} from 'reducers/activecase/activecaseSlice'

import { setSelectedDocumentStatus } from 'reducers/document/documentProcessingSlice'

import {
  SUBSCRIBE_DOMAIN_ENTITY_CHANGED_EVENT,
  SubscribeDomainEntityChangedEventResponse,
  SubscribeDomainEntityChangedEventVariables
} from 'share/subscriptions/subscription'

interface Props {
  accountId: number
}

const SubscriptionManager: FC<Props> = ({ accountId }) => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const documentProcessing = useAppSelector((state) => state.documentProcessing)
  const dispatch = useAppDispatch()

  const { data: dataSubscription } = useSubscription<
    SubscribeDomainEntityChangedEventResponse,
    SubscribeDomainEntityChangedEventVariables
  >(SUBSCRIBE_DOMAIN_ENTITY_CHANGED_EVENT, {
    variables: { accountId: accountId }
  })

  const [getCaseDashboard, { data: dataMatter }] =
    useLazyQuery<GetCaseLevelDashboardResponse>(GET_CASE_LEVEL_DASHBOARD, {
      fetchPolicy: 'network-only'
    })

  // check subscription for what event has changed
  useEffect(() => {
    if (dataSubscription) {
      const evt = dataSubscription as SubscribeDomainEntityChangedEventResponse
      if (
        evt.domainEntityChangedEvent.domainEntityType === 'Document' ||
        evt.domainEntityChangedEvent.domainEntityType === 'Matter' ||
        evt.domainEntityChangedEvent.domainEntityType === 'Course'
      ) {
        console.log(
          'domainEntityChangedEvent fired for ',
          evt.domainEntityChangedEvent.domainEntityType
        )
        if (activeCase && activeCase.matter && activeCase.matter.id) {
          /*    console.log(
            'subscription getCaseDashboard for matterId: ' +
              activeCase.matter.id
          ) */
          getCaseDashboard({ variables: { caseId: activeCase.matter.id } })

          // update selected document status if one exists
          if (documentProcessing) {
            if (documentProcessing.selectedDocument) {
              if (
                documentProcessing.selectedDocument.id ===
                evt.domainEntityChangedEvent.domainEntityId
              ) {
                if (evt.domainEntityChangedEvent.parameter1) {
                  dispatch(
                    setSelectedDocumentStatus(
                      evt.domainEntityChangedEvent.parameter1
                    )
                  )
                }
              }
            }
          }
        }
      }

      if (evt.domainEntityChangedEvent.domainEntityType === 'Notification') {
        // loadAllNotifications()
      }

      console.log(evt)
    }
  }, [dataSubscription])

  // matter changed event fired so reload case
  useEffect(() => {
    let newActiveCase: ActiveCase | null = null
    if (dataMatter) {
      newActiveCase = loadFirstActiveCaseRecordFromResponse(dataMatter)
      if (newActiveCase) {
        dispatch(setActiveCase(newActiveCase))
      }
    }
  }, [dataMatter])

  /* console.log('subscription data')
  console.dir(dataSubscription) */

  return null
}

export default SubscriptionManager
